var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 7.33333C17.5003 7.33333 15.8295 5.05685 14.4721 3.69854C13.1148 2.34022 11.239 1.5 9.16699 1.5C5.02486 1.5 1.66699 4.85786 1.66699 9C1.66699 13.1421 5.02486 16.5 9.16699 16.5C12.5862 16.5 15.4711 14.2119 16.3739 11.0833M17.5003 7.33333V2.33333M17.5003 7.33333H12.5003",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.cdaedc40c7c66dc3cd47e5030d9ff14b.svg";
export { ForwardRef as ReactComponent };